const channel_campaign_group_offers_export_type_options = [
  { label: "Filtry ofert", value: "offer_filters" },
  { label: "ID ofert", value: "offer_ids" },
];

export const getChannelCampaignGroupOffersExportType = (val) =>
  channel_campaign_group_offers_export_type_options.find(
    ({ value }) => value === val,
  )?.label;

export default channel_campaign_group_offers_export_type_options;
